// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.adCards {
    display: flex;
    flex-direction: column;
    gap: 12px;
    align-items: center;
    justify-content: center;
    /* width: 195px; */
    width: 100%;

    /* padding: 10px 26px; */
}

.myAds {
    display: flex;
    flex-direction: column;
    width: 100%;
    background: #FFE8AE;
    border-radius: 16px;
    position: relative;
    max-width: calc(100vw - 60px);
    width: 100%;
    /* overflow: hidden; */
    /* height: 138px; */
    gap: 11px;
    /* padding-left: 26px;
    padding-right: 26px; */
    padding: 17px 26px 10px 26px;

}

.Buttons {
    display: flex;
    align-items: center;
    justify-content: space-between;
    /* flex-wrap: wrap; */
    overflow-y: scroll;
    gap: 4px;
}

.Buttons::-webkit-scrollbar {
    width: 0;
  }

.linkNolineCreate {
    text-decoration: none;
}

.prodvigateButton {
    width: max-content;
    height: auto;
    padding: 8px 16px;
    border-radius: 8px;
    background: #8E3B00;
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
    font-family: Alegreya Sans;
    font-size: 14px;
    font-weight: 500;
    line-height: 16.8px;
    text-align: left;
    color: #FFF4D9;
    font-weight: 700;
}

.changeButton {
    width: max-content;
    height: auto;
    padding: 8px 16px;
    border-radius: 8px;
    background: #FFB800;
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
    font-family: Alegreya Sans;
    font-size: 14px;
    font-weight: 500;
    line-height: 16.8px;
    text-align: left;
    color: #8E3B00;
    font-weight: 700;
}

.deleteButton {
    width: max-content;
    height: auto;
    padding: 8px 16px;
    border-radius: 8px;
    background: #FF6B00;
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
    font-family: Alegreya Sans;
    font-size: 14px;
    font-weight: 500;
    line-height: 16.8px;
    text-align: left;
    color: #FFF4D9;
    font-weight: 700;
}

.textAds {
    color: #8E3B00;
    font-size: 20px;
    font-weight: 700;
}

.mainText {
    font-size: 16px;
    color: #8E3B00;

    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}`, "",{"version":3,"sources":["webpack://./src/components/Profile/MyAds/AdAds/AdAds.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,WAAW;;IAEX,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,6BAA6B;IAC7B,WAAW;IACX,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;IACT;0BACsB;IACtB,4BAA4B;;AAEhC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,qBAAqB;IACrB,kBAAkB;IAClB,QAAQ;AACZ;;AAEA;IACI,QAAQ;EACV;;AAEF;IACI,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,0BAA0B;IAC1B,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,0BAA0B;IAC1B,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,0BAA0B;IAC1B,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,cAAc;;IAEd,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;AAC3B","sourcesContent":[".adCards {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n    align-items: center;\n    justify-content: center;\n    /* width: 195px; */\n    width: 100%;\n\n    /* padding: 10px 26px; */\n}\n\n.myAds {\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    background: #FFE8AE;\n    border-radius: 16px;\n    position: relative;\n    max-width: calc(100vw - 60px);\n    width: 100%;\n    /* overflow: hidden; */\n    /* height: 138px; */\n    gap: 11px;\n    /* padding-left: 26px;\n    padding-right: 26px; */\n    padding: 17px 26px 10px 26px;\n\n}\n\n.Buttons {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    /* flex-wrap: wrap; */\n    overflow-y: scroll;\n    gap: 4px;\n}\n\n.Buttons::-webkit-scrollbar {\n    width: 0;\n  }\n\n.linkNolineCreate {\n    text-decoration: none;\n}\n\n.prodvigateButton {\n    width: max-content;\n    height: auto;\n    padding: 8px 16px;\n    border-radius: 8px;\n    background: #8E3B00;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border: none;\n    font-family: Alegreya Sans;\n    font-size: 14px;\n    font-weight: 500;\n    line-height: 16.8px;\n    text-align: left;\n    color: #FFF4D9;\n    font-weight: 700;\n}\n\n.changeButton {\n    width: max-content;\n    height: auto;\n    padding: 8px 16px;\n    border-radius: 8px;\n    background: #FFB800;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border: none;\n    font-family: Alegreya Sans;\n    font-size: 14px;\n    font-weight: 500;\n    line-height: 16.8px;\n    text-align: left;\n    color: #8E3B00;\n    font-weight: 700;\n}\n\n.deleteButton {\n    width: max-content;\n    height: auto;\n    padding: 8px 16px;\n    border-radius: 8px;\n    background: #FF6B00;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border: none;\n    font-family: Alegreya Sans;\n    font-size: 14px;\n    font-weight: 500;\n    line-height: 16.8px;\n    text-align: left;\n    color: #FFF4D9;\n    font-weight: 700;\n}\n\n.textAds {\n    color: #8E3B00;\n    font-size: 20px;\n    font-weight: 700;\n}\n\n.mainText {\n    font-size: 16px;\n    color: #8E3B00;\n\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
